import { Document, Image, Page, Text, View } from '@react-pdf/renderer'
import React from 'react'
import { renderToStaticMarkup } from 'react-dom/server'
import { useTranslation } from 'react-i18next'
import Html from 'react-pdf-html'
import CCLogo from '../../../../Images/Branding/cc-combination-blue.png'
import { FetchLicensedDirectorBillingDetailsResponse } from '../../../../swagger'
import {
  dateToSlashStringReinterpretedAsLocal,
  dateWithTimeToSlashString,
} from '../../../../utils/dateUtility'
import fullName from '../../../../utils/fullName'
import { styles } from '../BillingPDF/licensingBillingPdfStyles'
import { LcdLicensingBreakdownForPDF } from './LcdLicensingBreakdownForPDF'

export const LcdLicensingFeePDF: React.FC<{
  licensing: FetchLicensedDirectorBillingDetailsResponse
}> = ({ licensing }) => {
  const { t } = useTranslation()

  const preparedOnDate = dateWithTimeToSlashString(new Date())

  const programLabel = t(
    'LcdLicensingFeePDF.ProgramLabel',
    '{{ programType }} ({{ programDate }}) - {{ community }} Community',
    {
      programType: licensing.programType,
      programDate: dateToSlashStringReinterpretedAsLocal(
        licensing.semesterOneStartDate
      ),
      community: licensing.community,
    }
  )

  return (
    <Document title="License Fee Report">
      <Page size="LETTER" style={styles.page}>
        <Image style={styles.logo} src={CCLogo} />
        <View style={{ ...styles.billToContainer, flexDirection: 'column' }}>
          <Text style={{ ...styles.billToLabel, marginBottom: 4 }}>
            {t('LcdLicensingFeePDF.BillTo', 'License for {{ fullName }}', {
              fullName: fullName(licensing.director),
            })}
          </Text>
          <Text style={{ ...styles.billToLabel, fontWeight: 'normal' }}>
            {programLabel}
          </Text>
        </View>
        <Html>
          {renderToStaticMarkup(
            <LcdLicensingBreakdownForPDF licensing={licensing} />
          )}
        </Html>
        <View style={styles.preparedOnDateContainer}>
          <Text style={styles.preparedOnDate}>
            {t(
              'LcdLicensingFeePDF.PreparedOn',
              'Prepared on {{ preparedOnDate }}',
              {
                preparedOnDate,
              }
            )}
          </Text>
        </View>
      </Page>
    </Document>
  )
}
